// extracted by mini-css-extract-plugin
export default {"component":"NewEmployeesModal_component__zmONZ","modalContainer":"NewEmployeesModal_modalContainer__rQEu5","input":"NewEmployeesModal_input__rYbXY"};